'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { locale } from '@/constants/locale';

const { auth } = locale;

export default function NotFoundContent({ className }: { className?: string }) {
  const router = useRouter();

  return (
    <div
      className={`flex w-full flex-col items-center justify-center text-center ${className ?? ''}`}
    >
      <span className="from-foreground bg-linear-to-b to-transparent bg-clip-text text-[10rem] leading-none font-extrabold text-transparent">
        404
      </span>
      <h2 className="font-heading my-2 text-2xl font-bold">
        {auth.notFound.description}
      </h2>
      <p>{auth.notFound.message}</p>
      <div className="mt-8 flex justify-center gap-2">
        <Button onClick={() => router.back()} variant="default" size="lg">
          {auth.notFound.goBack}
        </Button>
        <Link
          href="/"
          className="border-input hover:bg-accent hover:text-accent-foreground focus-visible:ring-ring inline-flex h-10 items-center justify-center rounded-md border bg-transparent px-8 text-sm font-medium shadow-xs transition-colors focus-visible:ring-1 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
        >
          {auth.notFound.backToHome}
        </Link>
      </div>
    </div>
  );
}
